import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'gb-locked-prompt',
  templateUrl: './gb-locked-prompt.component.html',
  styleUrls: ['./gb-locked-prompt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbLockedPromptComponent implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.querySelector('.sidenav-container')?.classList.add('scrollblock')
  }

  ngOnDestroy(): void {
    document.querySelector('.sidenav-container')?.classList.remove('scrollblock')
  }
}
